export interface CastMember {
  name: string;
  character: string;
  desc: string;
  lead: boolean;
}

export const castMembers: CastMember[] = [
  {
    name: '李丽珍',
    character: '阿珍（Jane）',
    desc: '女主角。饰演叛逆而渴望自由的富家女，是整部影片的情感与叙事核心。',
    lead: true,
  },
  {
    name: '潘震伟',
    character: 'John',
    desc: '阿珍的男友，感情上的不忠成为阿珍出走、远行的直接导火索。',
    lead: true,
  },
  {
    name: '霍瑞华',
    character: 'David',
    desc: '年轻的作家，在旅途中与阿珍相遇，两人一见钟情。',
    lead: true,
  },
  { name: '黄光亮', character: '', desc: '参演本片。', lead: false },
  { name: '成奎安', character: '', desc: '参演本片。', lead: false },
  { name: '左颂昇', character: '', desc: '参演本片。', lead: false },
  { name: '邵传勇', character: '', desc: '参演本片。', lead: false },
  { name: '焦姣', character: '', desc: '参演本片。', lead: false },
  { name: '田青', character: '', desc: '参演本片。', lead: false },
  { name: '潘雁英', character: '', desc: '参演本片。', lead: false },
  { name: '余慕莲', character: '', desc: '参演本片。', lead: false },
];